import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DashboardModalViewComponent
} from './';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    DashboardModalViewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    DashboardModalViewComponent
  ]
})
export class DashboardModalModule { }
